import axios from 'axios';

import type { Employer, PaginatedResponse, ReportRequestPayload } from '../report-requests.types';

export interface GetReportEmployersParams {
  query?: string;
  page: number;
  perPage: number;
}

async function getReportEmployers(params: GetReportEmployersParams): Promise<PaginatedResponse<Employer>> {
  const { query, page, perPage } = params;
  const response = await axios.get('/reporting/employers', {
    params: query !== undefined ? { query, page, perPage } : { page, perPage },
  });
  return response.data;
}

async function createReportRequest(payload: ReportRequestPayload): Promise<void> {
  await axios.post('/reporting/report-requests', payload);
}

export const reportRequestsService = {
  getReportEmployers,
  createReportRequest,
};
